import sampleTestActions from "./actions";

const initialState = {
  sampleQuestionAnsAnswers : []
}

const sampleTestReducer = ( state = initialState, action) => {
  switch (action.type) {
    case sampleTestActions.SET_SAMPLE_QUESTIONS:
      return {
        ...state,
        sampleQuestionAnsAnswers : action.payload
      };
    default:
      return state;
  }
}

export default sampleTestReducer;